.picker {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  min-width: 0;
}

.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.label {
  color: var(--ink);
  font: var(--t-body-strong);
}

.input {
  width: 100%;
  height: var(--control-height);
  padding: 0 var(--space-3);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-control);
  background: var(--paper);
  color: var(--ink);
  font: var(--t-body);
}

.input::placeholder {
  color: var(--pencil);
}

.input[data-focused] {
  outline: var(--focus-ring);
  outline-offset: 0;
  border-color: var(--brand);
}

/* The browser's own clear button would add a second, unstyled control. */
.input::-webkit-search-cancel-button {
  appearance: none;
}

.description {
  color: var(--graphite);
  font: var(--t-small);
}

.list {
  display: flex;
  flex-direction: column;
  outline: none;
}

.list[data-empty] {
  display: none;
}

/* 44px rows (DESIGN.md §7), divided by rule lines like a table. */
.item {
  display: flex;
  align-items: center;
  min-height: var(--row-height);
  padding: var(--space-1) var(--space-3);
  border-bottom: 1px solid var(--rule);
  font: var(--t-body);
  cursor: pointer;
  outline: none;
}

.item[data-hovered],
.item[data-focused] {
  background: var(--brand-tint);
}

/* The highlighted row gets the same 3px ink bar as a selected queue row (DESIGN.md §6.3). */
.item[data-focused] {
  box-shadow: none;
  border-left: 3px solid var(--brand);
  padding-left: calc(var(--space-3) - 3px);
}

.item[data-focus-visible] {
  outline: var(--focus-ring);
  outline-offset: -2px;
}

.hint,
.message {
  color: var(--graphite);
  font: var(--t-body);
}

.empty,
.error {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-3);
  padding: var(--space-3) 0;
  color: var(--ink);
}

.error p {
  font: var(--t-body-strong);
}

.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
